import type { PosthogCohortOption } from './proactivity-experiments-types';

const pluralUsers = (count: number) => (count === 1 ? 'user' : 'users');

export const targetsSummary = (
  selectedCohort: PosthogCohortOption | undefined,
  additionalEmailCount: number
) => {
  const additionalEmails = additionalEmailCount
    ? ` Plus ${additionalEmailCount} additional ${additionalEmailCount === 1 ? 'email' : 'emails'}.`
    : '';
  if (!selectedCohort) {
    return additionalEmailCount
      ? `Targets ${additionalEmailCount} additional ${additionalEmailCount === 1 ? 'email' : 'emails'} only.`
      : 'Pick a cohort or add at least one email.';
  }
  if (selectedCohort.count === null) {
    return `Targets the members of ${selectedCohort.name}; PostHog did not report a count.${additionalEmails}`;
  }
  return `Targets ${selectedCohort.count} ${pluralUsers(selectedCohort.count)} in ${selectedCohort.name}.${additionalEmails}`;
};
